import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMarkerAdd = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMarkerAdd.dimensions.width} ${IconMarkerAdd.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="M6.75 18a.565.565 0 0 1-.398-.164C6.093 17.576 0 11.429 0 6.75A6.757 6.757 0 0 1 6.75 0a6.757 6.757 0 0 1 6.75 6.75c0 .222-.014.456-.053.69a.563.563 0 0 1-1.11-.187c.029-.171.038-.342.038-.503A5.631 5.631 0 0 0 6.75 1.125 5.631 5.631 0 0 0 1.125 6.75c0 3.575 4.283 8.438 5.625 9.874.195-.21.451-.49.746-.827a.561.561 0 1 1 .848.738c-.702.806-1.196 1.3-1.196 1.3A.561.561 0 0 1 6.75 18Z"
      />
      <Path
        fill={color || Color.premiumBlack}
        d="M6.75 10.125A3.38 3.38 0 0 1 3.375 6.75 3.38 3.38 0 0 1 6.75 3.375a3.38 3.38 0 0 1 3.375 3.375 3.38 3.38 0 0 1-3.375 3.375Zm0-5.625C5.51 4.5 4.5 5.51 4.5 6.75S5.51 9 6.75 9 9 7.99 9 6.75 7.99 4.5 6.75 4.5ZM13.5 18A4.504 4.504 0 0 1 9 13.5C9 11.018 11.018 9 13.5 9s4.5 2.018 4.5 4.5-2.018 4.5-4.5 4.5Zm0-7.875a3.38 3.38 0 0 0-3.375 3.375 3.38 3.38 0 0 0 3.375 3.375 3.38 3.38 0 0 0 3.375-3.375 3.38 3.38 0 0 0-3.375-3.375Z"
      />
      <Path
        fill={color || Color.premiumBlack}
        d="M15.188 14.063h-3.376a.563.563 0 0 1 0-1.126h3.376a.563.563 0 0 1 0 1.126Z"
      />
      <Path
        fill={color || Color.premiumBlack}
        d="M13.5 15.75a.563.563 0 0 1-.563-.563v-3.374a.563.563 0 0 1 1.126 0v3.374a.564.564 0 0 1-.563.563Z"
      />
    </Svg>
  )
}

IconMarkerAdd.dimensions = {
  width: 18,
  height: 18,
}

export default IconMarkerAdd
